import {Http} from '../dimijs/src/lib/sources/http';
import {ICrudFilter, ICrudList, ICrudPagination, ICrudSorting} from '../dimijs/src/lib/sources/source';
import {ITrack} from './types';

export const getTracksSource = (store: any, serialized?: {
    data: ICrudList<any>,
    filter: ICrudFilter<any>[],
    pagination: ICrudPagination,
    sorting?: ICrudSorting<any>[]
  }) => {
  if (serialized) {
    store.tracksSource.source.addSerializedState(serialized.data,
      serialized.filter, serialized.pagination, serialized.sorting);
  }
  return store.tracksSource as {
    inited: boolean,
    source: Http<ITrack, string>,
    tracksSorting: ICrudSorting<ITrack>[],
    tracksFilter: ICrudFilter<ITrack>[],
    tracksPagination: ICrudPagination,
  };
};

export const initTracksSource = (store: any, initProps: any) => {
  store.tracksSource = {
    inited: false,
    source: null as any,
    tracksSorting: [],
    tracksFilter: [],
    tracksPagination: {page: 0, countOnPage: 100},
  };
  store.tracksSource.source = new Http<ITrack, string>('_id',
    // @ts-ignore
    initProps && initProps.tracks ? {
      data: {
        // @ts-ignore
        data: initProps.tracks,
      },
      filter: store.tracksSource.tracksFilter,
      pagination: store.tracksSource.tracksPagination,
      sorting: store.tracksSource.tracksSorting,
    } : undefined);
  store.tracksSource.source.httpEndPoint = '/api/collections/tracks';
};
